import Button from "components/Buttons/StdButton";
import { FormattedMessage as FM } from "react-intl";

export function DeliveryActionFooter({
  selectedRows,
  activeTab,
  onDispatch,
  onCollect,
}) {
  if (!selectedRows || selectedRows.size === 0) return null;

  const totalAmount = Array.from(selectedRows.values()).reduce(
    (acc, cur) => acc + (cur.total_amount || 0) + (cur.delivery_amount || 0) + (cur.tip_amount || 0),
    0,
  );

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 w-2/4 max-w-4xl bg-zinc-900 text-white rounded-2xl shadow-2xl border border-zinc-800 p-4 flex items-center justify-between z-50 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="flex items-center gap-6">
        <div className="flex flex-col">
          <div className="flex items-center gap-3">
            <div className="flex flex-col">
              <span className="text-xs text-zinc-400">
                <FM id="sale.sale.delivery.panel.selected" />
              </span>
              <span className="text-xl font-black text-amber-400 justify-center text-center">
                {selectedRows.size}
              </span>
            </div>
            <div className="h-8 w-px bg-zinc-800 mx-2"></div>
            <div className="flex flex-col">
              <span className="text-xs text-zinc-400">
                <FM id="sale.sale.delivery.panel.total" />
              </span>
              <span className="text-xl font-black">
                $ {Number(totalAmount).toLocaleString("es-CO")}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex gap-3 tablet:text-sm">
        {activeTab === "to_dispatch" && (
          <Button
            content="delivery.panel.dispatch"
            color="amber"
            className="h-12 px-8 shadow-lg font-black uppercase tracking-wider text-sm transition-all hover:scale-105 active:scale-95"
            onClick={onDispatch}
          />
        )}
        {activeTab === "collection" && (
          <Button
            content="delivery.panel.collection"
            color="amber"
            className="h-12 px-8 shadow-lg font-black uppercase tracking-wider text-sm transition-all hover:scale-105 active:scale-95"
            onClick={onCollect}
          />
        )}
      </div>
    </div>
  );
}
